import { render, staticRenderFns } from "./GreatEvent.vue?vue&type=template&id=387a8b28&scoped=true&"
import script from "./GreatEvent.vue?vue&type=script&lang=js&"
export * from "./GreatEvent.vue?vue&type=script&lang=js&"
import style0 from "./GreatEvent.vue?vue&type=style&index=0&id=387a8b28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a8b28",
  null
  
)

export default component.exports